import { Directive } from '@angular/core';
import { ElementRef, HostListener, Output, EventEmitter } from '@angular/core';

/**
 * A directive to select files from the users's file system.
 */
@Directive({
	selector: '[fileinput]'
})
export class FileinputDirective {
	@Output() filesSelected = new EventEmitter<File[]>();

	constructor(private el: ElementRef) { }

	@HostListener('change', ['$event'])
	onFileChange(event: Event) {
		const input = event.target as HTMLInputElement;
		if (input && input.files) {
			const files = Array.from(input.files);
			this.filesSelected.emit(files);
		}
	}
}
